import React from "react";
//#region redux
import { AppState } from "store";
import { useSelector } from "react-redux";
//#endregion
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { CopyTextField, StyledButton } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

interface TipDialogContentProps {
  description?: React.ReactNode;
}

const TipDialogContent: React.FC<TipDialogContentProps> = ({ description }) => {
  const loggedInUser = useSelector((store: AppState) => store.auth.loggedInUser);
  const link = `https://wint.se/kampanj/tipsa-en-van?referral_id=${loggedInUser.personId}`;
  const copyButtonOnclick = () => {
    navigator.clipboard.writeText(link);
  };

  return (
    <Grid container>
      <Grid item className={cssExports.walkingManContent}>
        {description ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TipDialogDescription)}
      </Grid>
      <Grid container rowSpacing={1}>
        <Grid item>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TipDialogFieldLabel)}</Grid>
        <Grid container item direction="row">
          <Grid item xs>
            <CopyTextField>{link}</CopyTextField>
          </Grid>
          <Grid item>
            <StyledButton size="xs" className={cssExports.smallbtn} onClick={copyButtonOnclick}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TipDialogButtonText)}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TipDialogContent;
